import { call, put, takeLatest } from "redux-saga/effects";
import {
  deleteSubjectStart,
  deleteSubjectSuccess,
  deleteSubjectFailure,
} from "../reducer";
import { Notify } from "@flexisaf/flexibull2";
import { deleteSubject } from "../../../services/subject";

export function* handleDeleteSubject({ payload }) {
  const { id, cb } = payload;

  const response = yield call(deleteSubject, { id });
  const { success, raw, message } = response;

  if (success) {
    yield put(deleteSubjectSuccess());
    Notify("Subject deleted successfully", { status: "success" });
    if (cb) {
      cb();
    }
  } else {
    yield put(deleteSubjectFailure(message || raw.error));
    Notify(message || raw.error, { status: "error" });
  }
}

export default function* onSubjectDelete() {
  yield takeLatest(deleteSubjectStart.type, handleDeleteSubject);
}
